import { useCallback, useMemo, useState } from 'react';
import { normalizeSearchPhrase } from '../../../../helpers/normalizeSearchPhrase';
import { useFilterSuggestionsQuery } from '../../../../hooks/api/useFilterSuggestionsApi';

interface UseApiFilterSuggestionsProps {
  filterName: string;
  enabled?: boolean;
}

export const useApiFilterSuggestions = ({ filterName, enabled = true }: UseApiFilterSuggestionsProps) => {
  const [searchPhrase, setSearchPhrase] = useState('');

  const { data, isLoading, isFetching, error } = useFilterSuggestionsQuery(
    { searchPhrase, filterName },
    { enabled: enabled && !!filterName },
  );

  const onSearchPhraseChange = useCallback((value: string) => {
    setSearchPhrase(normalizeSearchPhrase(value));
  }, []);

  const suggestions = useMemo(() => data ?? [], [data]);

  return {
    suggestions,
    isLoading: isLoading || isFetching,
    error: error?.message ?? null,
    onSearchPhraseChange,
  };
};
